import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// //获取原型对象上的push函数
// const originalPush = Router.prototype.push
// //修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

let router = new Router({
  routes: [
    {
      path: '/',
      redirect:'login'
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login/index'], resolve)
    },
    {
      path: '/functionPage',
      name: 'functionPage',
      component: resolve => require(['@/views/functionPage/index'], resolve),
      children: [
        {
          path: '/functionPage/dataList',
          name: 'dataList',
          component: resolve => require(['@/views/functionPage/dataList'], resolve),
        },
        {
          path: '/functionPage/collectionList',
          name: 'collectionList',
          component: resolve => require(['@/views/functionPage/collectionList'], resolve),
        },
        {
          path: '/functionPage/dataChart',
          name: 'dataChart',
          component: resolve => require(['@/views/functionPage/dataChart'], resolve),
        },
        {
          path: '/functionPage/systemConfig',
          name: 'systemConfig',
          component: resolve => require(['@/views/functionPage/systemConfig'], resolve),
        },
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next({
      path: '/login'
    })
    return
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js